import { isNil } from 'lodash';

import { decimalNumber } from '@app/shared/common';

import { NumberFormatService } from '../services/number-format/number-format.service';

const calculatePercentage = (originValue: number, value: number): number => {
  let calculateNumber: number;
  if (
    isNil(value) ||
    isNil(originValue) ||
    Number(value) === 0 ||
    Number(originValue) === 0
  ) {
    calculateNumber = 0;
  } else {
    calculateNumber = decimalNumber(originValue).div(value).valueOf();
  }

  return calculateNumber;
};

const formatDiffNumberAndPercentage = <T = object>(
  item: T,
  diffField: string,
  originField: string,
  numberFormatService: NumberFormatService,
): string => {
  const diffNumber: string = numberFormatService.getNumberFormatter(true)({
    value: item[diffField],
  });

  const percentageNumber: number = calculatePercentage(
    item[diffField],
    item[originField],
  );

  const percentageNumberFormatter: string =
    numberFormatService.percentageNumberFormat(percentageNumber);

  return `${diffNumber}(${percentageNumberFormatter})`;
};

export { calculatePercentage, formatDiffNumberAndPercentage };
